/**
 * Decorator for use on class methods to bind the class instance context ("this") to them.
 * Using the decorator is the equivalent of doing `this.method = this.method.bind(this)` in the constructor.
 * Only use on instance methods.
 *
 * Based on Stage 3 Decorators proposal as of 2023-11: https://github.com/tc39/proposal-decorators
 *
 * @param {function} value
 * @param {string} name
 * @param {string} kind
 * @param {boolean} isStatic
 * @param {function} addInitializer
 */
export default function bound(value, { name, kind, static: isStatic, addInitializer }) {
  if (kind !== 'method') {
    throw new Error(
      `Using '@bound' decorator on '${name}' which is of kind '${kind}'. This decorator is only meant for methods.`,
    );
  }

  if (isStatic) {
    throw new Error(
      `Using '@bound' decorator on '${name}' which is a static method. This decorator is only meant for instance methods.`,
    );
  }

  addInitializer(function initializer() {
    this[name] = this[name].bind(this);
  });
}
